import styled from 'styled-components';

import Scene from './Scene';
import { toVw, toVwMobile, toVwTablet } from '../utils/styles';
import mq from '@/utils/media-queries';

const PADDING_TOP = 178;
const PADDING_BOTTOM = 189;

const Styled = styled(Scene)`
  padding-top: ${toVw(PADDING_TOP)};
  padding-bottom: ${toVw(PADDING_BOTTOM)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(PADDING_TOP)};
    padding-bottom: ${toVwTablet(PADDING_BOTTOM)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(PADDING_TOP)};
    padding-bottom: ${toVwMobile(PADDING_BOTTOM)};
  `)};
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/scenes/SceneList.js